import React from 'react';
import { useTranslation } from '../i18n/useTranslation';
import { albumTracksEmptyState } from '../utils/albumTracksEmptyState';

/** Tracks tab with no rows: loading / local empty / real "not streamable" / couldn't load + retry. */
export default function AlbumTracksEmptyState({ onRetry, ...args }) {
  const { t } = useTranslation();
  const state = albumTracksEmptyState(args);
  return (
    <div className="py-8 text-center" style={{ color: 'var(--text-secondary, rgba(255,255,255,0.5))' }}>
      <p data-empty-state={state.kind}>{t(state.messageKey)}</p>
      {state.canRetry && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 px-4 py-2 rounded-xl text-sm font-semibold"
          style={{ background: '#C9A84C', color: '#1a1a2e' }}
        >
          {t('album.tracks.retry')}
        </button>
      )}
    </div>
  );
}
